<template>
  <div>
    <div class="mask">
      <div class="changePassword">
        <div class="changePassword-play">
          <div class="modify">
            <Button type="primary" @click="modifyInformation">{{$t('i.personalInformation.modifyInformation')}}</Button>
          </div>
          <div class="change">
            <Button type="primary" @click="changePassword">{{$t('i.personalInformation.changePassword')}}</Button>
          </div>
          <div class="examinationLnformation">
            <Button type="primary" @click="openLearningRecords">{{$t('i.personalInformation.viewLearningRecords')}}</Button>
            <span class="md-close" @click="closeModify">×</span>
          </div>
          <div v-show="isShow3" class="closeLearningRecords">
            <view-learning-records  :courseContent = "courseContent"  @closeLearningRecords="()=>isShow3 = false" ></view-learning-records>
          </div>
          <div v-show="flag" class="changePasswordPopup">
            <change-password  :changePasswordFormData="changePasswordFormData" :pwdQuestionList="pwdQuestionList"  @closeChangePasswd="()=>flag = false"></change-password>
          </div>
          <div class="information">
            <div class="words">
              <div class="words-span1">
                <span>{{$t('i.personalInformation.typeOfCompany')}}:</span>
                <p class="words-p">{{personalInformation.company}}</p>
              </div>
              <div class="words-span1">
                <span>{{$t('i.personalInformation.departmentName')}}:</span>
                <p class="words-p">{{personalInformation.org_name}}</p>
              </div>
            </div>
            <div class="thats">
              <div class="thats-text">
                <span>{{$t("i.personalInformation.chineseName")}}:</span>
                <Input :disabled="isInformation" :placeholder="personalInformation.empname" :value="personalInformation.empname"  v-model="personalInformation.empname"  style="width: 200px;"/>
              </div>
              <div class="thats-text">
                <span>{{$t("i.personalInformation.japaneseName")}}:</span>
                <Input :disabled="isInformation" :placeholder="personalInformation.empnamej"  :value="personalInformation.empnamej"  v-model="personalInformation.empnamej"  style="width: 200px;"/>
              </div>
              <div class="thats-text">
                <span>{{$t("i.personalInformation.phoneAreaVal")}}:</span>

                <Select style="width:200px" v-model="personalInformation.area" :disabled="isInformation">
                  <Option v-for="(list,index) in areaList" :key="index" :value="list.value">{{ list.label }}</Option>
                </Select>

              </div>
              <div class="thats-text">
                <span>{{$t("i.personalInformation.phoneNumber")}}:</span>
                <Input :disabled="isInformation" :placeholder="personalInformation.mobile"  :value="personalInformation.mobile" v-model="personalInformation.mobile" style="width: 200px;"/>
              </div>
              <div class="thats-text">
                <span>{{$t("i.personalInformation.email")}}:</span>
                <Input :disabled="isInformation" :placeholder="personalInformation.email" :value="personalInformation.email" v-model="personalInformation.email" style="width: 200px;"/>
              </div>
            </div>
            <div class="Preservation" v-show="!isInformation">
              <Button type="primary" @click="savePersonInfo">{{$t('i.changePassword.preservation')}}</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ChangePassword from "../changePassword/changePassword";
  import ViewLearningRecords from "../viewLearningRecords/viewLearningRecords";
  import { mapState } from "vuex";

  export default {
    components: {ChangePassword,ViewLearningRecords},
    props:{
      personalInformation: {}
    },
    data(){
      return{
        flag: false,
        isInformation: true,
        isShow3: false,
        courseContent:[],
        areaVal:[],
        changePasswordFormData:{},
        pwdQuestionList:[],
      }
    },
    computed: {
      ...mapState({
        areaList: (state) => state.areaList,
      }),
    },
    methods:{
      // async getArea(){
      //   const url = this.Constants.serverURL + "/area/area_zh_CN.json";
      //   const json = await this.RequestUtil.requestJson(url);
      //   this.areaList = eval(json);
      // },
      closeModify(){
        this.$emit('close');
        this.isInformation = true;
      },
      modifyInformation(){
        this.isInformation = false;
      },
      async openLearningRecords(){
        const json = await this.RequestUtil.request("/front/courseware/showStudyInfo");
        if (json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.courseContent = json.datas.data;
          }
        }
        this.isShow3 = true;
      },

      async changePassword(){
        const json1 = await this.RequestUtil.request("/front/person");
        if(json1){
          if(json1.statusCode == this.Constants.statusCode.ok){
            this.changePasswordFormData = json1.datas.user;
            console.info(json1.datas.pwdquestion)
            this.pwdQuestionList = json1.datas.pwdquestion;
          }
        }
        this.flag = true;
      },

      async savePersonInfo(){
        let user =  {};
        user.id = this.personalInformation.id;
        user.empname = this.personalInformation.empname;
        user.empnamej = this.personalInformation.empnamej;
        user.email = this.personalInformation.email;
        user.mobile = this.personalInformation.mobile;
        user.area = this.personalInformation.area;
        const json = await this.RequestUtil.request("/front/person/save",user);
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.$Message.success({
              content:  json.message,
              duration: 3,
              closable: true
            });
          }else{
            this.$Message.error({
              content:  json.message,
              duration: 3,
              closable: true
            });
          }
        }
      }
    },
    name: "personalInformation",
    mounted(){
      // this.getArea();
    }
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  .changePassword{
    width: 100%;
    height: 500px;

  }
  .changePassword-play{
    width: 700px;
    height: 500px;
    margin: 100px auto;
    border-radius: 20px;
    border: 2px solid #ccc;
    background-color: #fff;
  }
  .modify,
  .change,
  .examinationLnformation
  {
    width: 230px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    float: left;
  }
  .changePassword-play Button{
    width: 120px;
    height: 30px;
    margin-top: 15px;
  }
  .md-close{
    font-size: 45px;
    float: right;
    margin-right: 15px;
    line-height: 65px;
    cursor: pointer;
    color: #2d8cf0;
  }
  .changePasswordPopup{
    position: absolute;
    z-index: 111;
  }
  .closeLearningRecords{
    position: absolute;
    z-index: 111;
  }
  .thats{
    width: 696px;
    height: 30px;
    margin-bottom: 10px;
  }
  .information{
    width: 696px;
    height: 400px;
    float: left;
    margin-top: 10px;
  }
  .words{
    width: 696px;
    height: 30px;
    margin-bottom: 15px;
  }
  .words-span1{
    width: 348px;
    height: 30px;
    float: left;
    margin-top: 10px;
  }
  .thats-text{
    width: 348px;
    height: 30px;
    float: left;
    margin-bottom: 20px;
  }
  .words-p{
    margin-top: 5.5px;
  }
  .information span{
    width: 90px;
    height: 20px;
    display: inline-block;
    text-align: right;
    margin-right: 5px;
    float: left;
    line-height: 30px;
  }
  .Preservation{
    width: 120px;
    height: 30px;
    margin-left: 140px;
    margin-top: -14px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personalInformation/personalInformation.vue